import React, { useContext, useState } from 'react';
import { Button } from '@material-ui/core';
import {
  GlobalContext,
  CLOSE_WIDGET,
} from '@mummssoftware/global-context/GlobalContext';
import { HopeGlobalContext } from '@mummssoftware/global-context';
import { useStyles } from '@mummssoftware/common-ui/VisitAttributeSelector';
import { DeleteVisitConfirmation } from '@mummssoftware/common-ui/DeleteVisitConfirmation';
import { SET_VISIT_ALERT, SHOW_TASKS } from '../Context/constants';
import { VisitContext } from '../Context/contexts/VisitContext';
import defaults from '../../translations/en.json';

export const DeleteVisitBtn = ({
  disabled: disabledFromParent = false,
}: {
  disabled?: boolean;
}) => {
  const classes = useStyles();

  const { dispatchVisit, deleteOpenVisit, canDeleteOpenVisit } = useContext(
    VisitContext,
  );
  const { resetHopeWorkflow } = useContext(HopeGlobalContext);
  const { appVisit, dispatch: globalContextDispatch } = useContext(
    GlobalContext,
  );

  const [okToDelete, setOkToDelete] = useState(false);
  const [isDisabled, setDisabled] = useState(false);
  const [btnText, setBtnText] = useState(
    appVisit?.id ? defaults.discard : defaults.cancel,
  );

  const onDelete = async () => {
    setOpenDialog(false);
    setDisabled(true);
    globalContextDispatch({
      type: CLOSE_WIDGET,
      payload: { componentName: 'Forms' },
    });
    setBtnText(defaults.deleting);
    const wasDeleted = await deleteOpenVisit();
    if (!wasDeleted) {
      setBtnText(defaults.cancel);
      dispatchVisit({
        type: SET_VISIT_ALERT,
        payload: {
          text: defaults.deleteVisitErrorMsg,
          severity: 'error',
        },
      });
    } else {
      resetHopeWorkflow();
    }
  };

  const onDiscard = async () => {
    dispatchVisit({
      type: SHOW_TASKS,
      payload: false,
    });
    const isOkToDelete = await canDeleteOpenVisit();
    if (isOkToDelete) {
      setOkToDelete(true);
    }
    setOpenDialog(true);
  };

  // Dialog Controls
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const setClosed = () => {
    setOpenDialog(false);
    setTimeout(() => {
      setOkToDelete(false);
    }, 500);
  };

  return (
    <>
      <DeleteVisitConfirmation
        open={openDialog}
        setClosed={setClosed}
        onDelete={onDelete}
        okToDelete={okToDelete}
        deleteText={defaults.deleteOpenVisitConfMsg}
      />
      <Button
        size="small"
        variant="contained"
        color="primary"
        disabled={isDisabled || disabledFromParent}
        onClick={onDiscard}
        classes={{
          root: classes.button,
        }}
      >
        {btnText}
      </Button>
    </>
  );
};
